const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the pie chart component
 * @argument {Application} Application the service defined to manage Application specific tools and functions
 */


app.directive('barChart', [function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      data: '=',
      colors: '=?'
    },
    template: require('../../templates/directives/bar-chart.html'),
    link: function (scope, element, attrs) {
      scope.items = [];

      scope.colors = scope.colors || ['#21bef1', '#36c26e', '#e86257', '#fd8126', '#c9cacb'];

      scope.isEmoji = function(str){
        var res = str.match(/^\&\#/);
        if (res){
          return true;
        } else {
          return false;
        }
      };

      var init = function init () {
        scope.items = [];
        var max;
        var most = 0;
        var total = 0;
        for (var key in scope.data) {
          if (scope.data[key] > most) {
            most = scope.data[key];
          }
          total += scope.data[key];
        }

        if (most < 5) {
          scope.max = 5;
        } else if (most < 10) {
          scope.max = 10;
        } else if (most < 100) {
          scope.max = Math.ceil(most / 10) * 10;
        } else {
          scope.max = Math.ceil(most / 100) * 100;
        }

        var colorOptions = scope.colors.slice(1);
        var index = 0;
        for (var key in scope.data) {
          scope.items.push({
            name: key,
            color: scope.colors[index],
            height: scope.data[key] / scope.max * 100,
            value: scope.data[key],
            percent: total === 0 ? 0 : Math.round(scope.data[key] / total * 100)
          });
          index++;
        }
      };

      scope.$watch('data', function(newVal, oldVal) {
        if (newVal) {
          init();
        }
      }, true);

      if (scope.data) {
        init();
      }

    }
  };
}]);